import { QuotaAnalyticsResponse } from "../dashboard.interface";

export const mockAnalyticsQuota: QuotaAnalyticsResponse = {
  success: true,
  msg: "OK",
  time: new Date().toISOString(),
  ver: "1.0",
  res: {
  quotaUsageAnalyticsTotalDto: {
	quotaComparePreviousMonth: {
	  compare: "INCREASE",
	  percentage: 76.32,
	},
	totalVolume: 3705,
	totalAllocated: 2700,
	deliveredVolume: 145090000,
	remainingVolume: 1000,
	usagePercentage: 48,

	topNewSuppliers: [
	  {
		id: "1",
		companyName: "ООО Мясокомбинат1",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 1000,
		totalAllocated: 3700,
	  },
	  {
		id: "2",
		companyName: "ООО Мясокомбинат2",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 2000,
		totalAllocated: 5800,
	  },
	  {
		id: "3",
		companyName: "ООО Мясокомбинат3",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 5000,
		totalAllocated: 6700,
	  },
	  {
		id: "4",
		companyName: "ООО Мясокомбинат4",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 2000,
		totalAllocated: 3400,
	  },
	  {
		id: "5",
		companyName: "ООО Мясокомбинат5",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 1500,
		totalAllocated: 1600,
	  }
	],
	topHistoricalSuppliers: [
	  {
		id: "1",
		companyName: "ООО Мясокомбинат1",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 1000,
		totalAllocated: 3700,
	  },
	  {
		id: "2",
		companyName: "ООО Мясокомбинат2",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 2000,
		totalAllocated: 5800,
	  },
	  {
		id: "3",
		companyName: "ООО Мясокомбинат3",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 5000,
		totalAllocated: 6700,
	  },
	  {
		id: "4",
		companyName: "ООО Мясокомбинат4",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 2000,
		totalAllocated: 3400,
	  },
	  {
		id: "5",
		companyName: "ООО Мясокомбинат5",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 1500,
		totalAllocated: 1600,
	  }
	],
	antiTopNewSuppliers: [
	  {
		id: "1",
		companyName: "ООО Мясокомбинат1",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 1000,
		totalAllocated: 3700,
	  },
	  {
		id: "2",
		companyName: "ООО Мясокомбинат2",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 2000,
		totalAllocated: 5800,
	  },
	  {
		id: "3",
		companyName: "ООО Мясокомбинат3",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 5000,
		totalAllocated: 6700,
	  },
	  {
		id: "4",
		companyName: "ООО Мясокомбинат4",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 2000,
		totalAllocated: 3400,
	  },
	  {
		id: "5",
		companyName: "ООО Мясокомбинат5",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 1500,
		totalAllocated: 1600,
	  }
	],
	antiTopHistoricalSuppliers: [
	  {
		id: "1",
		companyName: "ООО Мясокомбинат1",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 1000,
		totalAllocated: 3700,
	  },
	  {
		id: "2",
		companyName: "ООО Мясокомбинат2",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 2000,
		totalAllocated: 5800,
	  },
	  {
		id: "3",
		companyName: "ООО Мясокомбинат3",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 5000,
		totalAllocated: 6700,
	  },
	  {
		id: "4",
		companyName: "ООО Мясокомбинат4",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 2000,
		totalAllocated: 3400,
	  },
	  {
		id: "5",
		companyName: "ООО Мясокомбинат5",
		inn: "1234567890",
		supplierType: "NEW_SUPPLIER",
		deliveredVolume: 1500,
		totalAllocated: 1600,
	  }
	],

	newApplications: [
	  {
		applicationId: 1,
		companyName: "ООО Мясокомбинат1",
		createdAt: "18.09.2025 09:29:54",
	  },
	  {
		applicationId: 2,
		companyName: "ООО Мясокомбинат2",
		createdAt: "18.09.2025 09:29:54",
	  },
	  {
		applicationId: 3,
		companyName: "ООО Мясокомбинат3",
		createdAt: "18.09.2025 09:29:54",
	  },
	],
	expiringApplications: [
	  {
		applicationId: 1,
		companyName: "ООО Мясокомбинат",
		createdAt: "18.09.2025 09:29:54",
	  },
	],

	quotaNewSupplierTypeLimit: {
	  supplierType: "NEW_SUPPLIER",
	  totalAllocated: 2700,
	  deliveredVolume: 2700,
	},
	quotaHistoricalSupplierTypeLimit: {
	  supplierType: "HISTORICAL_SUPPLIER",
	  totalAllocated: 2700,
	  deliveredVolume: 3700,
	},

	quotaDeadlines: [
	  {
		deadlineInfo: "1-го этапа распределения для ИсП (1 декабря 2024) — прошёл",
		daysUntilDeadline: 10,
		deadlineDate: "2024-12-01",
	  },
	  {
		deadlineInfo: "2-го этапа распределения для ИсП (1 апреля 2025) — прошёл",
		daysUntilDeadline: 30,
		deadlineDate: "2025-04-01",
	  },
	],

	meatType: [
	  {
		id: 3,
		nameRu: "Свинины",
		nameKy: "Чочко эти",
		alias: "PORK"
	  },
	  {
		id: 2,
		nameRu: "КРС",
		nameKy: "Уй эти",
		alias: "BEEF",
	  },
	  {
		id: 1,
		nameRu: "Курицы",
		nameKy: "Тоок",
		alias: "CHICKEN",
	  }
	],

	title: "Итоговый анализ",
  },

  quotaUsageAnalyticsDtoList: [
	{
	  quotaComparePreviousMonth: {
		compare: "INCREASE",
		percentage: 56.32,
	  },
	  quotaId: 1,
	  totalVolume: 3705,
	  usagePercentage: 75,
	  totalAllocated: 2700,
	  deliveredVolume: 778000,
	  remainingVolume: 1000,

	  topNewSuppliers: [
		{
		  id: "1",
		  companyName: "ООО Мясокомбинат1",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1000,
		  totalAllocated: 3700,
		},
		{
		  id: "2",
		  companyName: "ООО Мясокомбинат2",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 5800,
		},
		{
		  id: "3",
		  companyName: "ООО Мясокомбинат3",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 5000,
		  totalAllocated: 6700,
		},
		{
		  id: "4",
		  companyName: "ООО Мясокомбинат4",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 3400,
		},
		{
		  id: "5",
		  companyName: "ООО Мясокомбинат5",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1500,
		  totalAllocated: 1600,
		}
	  ],
	  topHistoricalSuppliers: [
		{
		  id: "1",
		  companyName: "ООО Мясокомбинат1",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1000,
		  totalAllocated: 3700,
		},
		{
		  id: "2",
		  companyName: "ООО Мясокомбинат2",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 5800,
		},
		{
		  id: "3",
		  companyName: "ООО Мясокомбинат3",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 5000,
		  totalAllocated: 6700,
		},
		{
		  id: "4",
		  companyName: "ООО Мясокомбинат4",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 3400,
		},
		{
		  id: "5",
		  companyName: "ООО Мясокомбинат5",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1500,
		  totalAllocated: 1600,
		}
	  ],
	  antiTopNewSuppliers: [
		{
		  id: "1",
		  companyName: "ООО Мясокомбинат1",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1000,
		  totalAllocated: 3700,
		},
		{
		  id: "2",
		  companyName: "ООО Мясокомбинат2",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 5800,
		},
		{
		  id: "3",
		  companyName: "ООО Мясокомбинат3",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 5000,
		  totalAllocated: 6700,
		},
		{
		  id: "4",
		  companyName: "ООО Мясокомбинат4",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 3400,
		},
		{
		  id: "5",
		  companyName: "ООО Мясокомбинат5",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1500,
		  totalAllocated: 1600,
		}
	  ],
	  antiTopHistoricalSuppliers: [
		{
		  id: "1",
		  companyName: "ООО Мясокомбинат1",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1000,
		  totalAllocated: 3700,
		},
		{
		  id: "2",
		  companyName: "ООО Мясокомбинат2",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 5800,
		},
		{
		  id: "3",
		  companyName: "ООО Мясокомбинат3",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 5000,
		  totalAllocated: 6700,
		},
		{
		  id: "4",
		  companyName: "ООО Мясокомбинат4",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 3400,
		},
		{
		  id: "5",
		  companyName: "ООО Мясокомбинат5",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1500,
		  totalAllocated: 1600,
		}
	  ],

	  quotaNewSupplierTypeLimit: {
		supplierType: "NEW_SUPPLIER",
		totalAllocated: 2000,
		deliveredVolume: 800,
	  },
	  quotaHistoricalSupplierTypeLimit: {
		supplierType: "HISTORICAL_SUPPLIER",
		totalAllocated: 1705,
		deliveredVolume: 200,
	  },

	  quotaDeadlines: [
		{
		  deadlineInfo: "1-го этапа распределения для ИсП (1 декабря 2024) — прошёл",
		  daysUntilDeadline: 21,
		  deadlineDate: "2024-12-01",
		},
		{
		  deadlineInfo: "2-го этапа распределения для ИсП (1 апреля 2025) — прошёл",
		  daysUntilDeadline: 12,
		  deadlineDate: "2025-04-01",
		},
	  ],

	  newApplications: [
		{
		  applicationId: 2,
		  companyName: "ИП Поставщик Куры",
		  createdAt: "18.09.2025 10:00:00",
		},
		{
		  applicationId: 2,
		  companyName: "ИП Поставщик Куры",
		  createdAt: "18.09.2025 10:00:00",
		},
		{
		  applicationId: 2,
		  companyName: "ИП Поставщик Куры",
		  createdAt: "18.09.2025 10:00:00",
		},
	  ],
	  expiringApplications: [],

	  meatType: {
		id: 1,
		nameRu: "Курицы",
		nameKy: "Тоок",
		alias: "CHICKEN",
	  },
	  title: "Квота на 2025 - год (Куры)",
	},
	{
	  quotaComparePreviousMonth: {
		compare: "DECREASE",
		percentage: 12.5,
	  },
	  quotaId: 2,
	  totalVolume: 5000,
	  usagePercentage: 30,
	  totalAllocated: 3000,
	  deliveredVolume: 9050,
	  remainingVolume: 2100,

	  topNewSuppliers: [
		{
		  id: "1",
		  companyName: "ООО Мясокомбинат1",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1000,
		  totalAllocated: 3700,
		},
		{
		  id: "2",
		  companyName: "ООО Мясокомбинат2",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 5800,
		},
		{
		  id: "3",
		  companyName: "ООО Мясокомбинат3",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 5000,
		  totalAllocated: 6700,
		},
		{
		  id: "4",
		  companyName: "ООО Мясокомбинат4",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 3400,
		},
		{
		  id: "5",
		  companyName: "ООО Мясокомбинат5",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1500,
		  totalAllocated: 1600,
		}
	  ],
	  topHistoricalSuppliers: [
		{
		  id: "1",
		  companyName: "ООО Мясокомбинат1",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1000,
		  totalAllocated: 3700,
		},
		{
		  id: "2",
		  companyName: "ООО Мясокомбинат2",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 5800,
		},
		{
		  id: "3",
		  companyName: "ООО Мясокомбинат3",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 5000,
		  totalAllocated: 6700,
		},
		{
		  id: "4",
		  companyName: "ООО Мясокомбинат4",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 3400,
		},
		{
		  id: "5",
		  companyName: "ООО Мясокомбинат5",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1500,
		  totalAllocated: 1600,
		}
	  ],
	  antiTopNewSuppliers: [
		{
		  id: "1",
		  companyName: "ООО Мясокомбинат1",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1000,
		  totalAllocated: 3700,
		},
		{
		  id: "2",
		  companyName: "ООО Мясокомбинат2",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 5800,
		},
		{
		  id: "3",
		  companyName: "ООО Мясокомбинат3",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 5000,
		  totalAllocated: 6700,
		},
		{
		  id: "4",
		  companyName: "ООО Мясокомбинат4",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 3400,
		},
		{
		  id: "5",
		  companyName: "ООО Мясокомбинат5",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1500,
		  totalAllocated: 1600,
		}
	  ],
	  antiTopHistoricalSuppliers: [
		{
		  id: "1",
		  companyName: "ООО Мясокомбинат1",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1000,
		  totalAllocated: 3700,
		},
		{
		  id: "2",
		  companyName: "ООО Мясокомбинат2",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 5800,
		},
		{
		  id: "3",
		  companyName: "ООО Мясокомбинат3",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 5000,
		  totalAllocated: 6700,
		},
		{
		  id: "4",
		  companyName: "ООО Мясокомбинат4",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 3400,
		},
		{
		  id: "5",
		  companyName: "ООО Мясокомбинат5",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1500,
		  totalAllocated: 1600,
		}
	  ],


	  quotaNewSupplierTypeLimit: {
		supplierType: "NEW_SUPPLIER",
		totalAllocated: 1200,
		deliveredVolume: 300,
	  },
	  quotaHistoricalSupplierTypeLimit: {
		supplierType: "HISTORICAL_SUPPLIER",
		totalAllocated: 3800,
		deliveredVolume: 600,
	  },

	  quotaDeadlines: [
		{
		  deadlineInfo: "1-го этапа распределения для ИсП (1 декабря 2024) — прошёл",
		  daysUntilDeadline: 30,
		  deadlineDate: "2024-12-01",
		},
		{
		  deadlineInfo: "2-го этапа распределения для ИсП (1 апреля 2025) — прошёл",
		  daysUntilDeadline: 30,
		  deadlineDate: "2025-04-01",
		},
	  ],

	  newApplications: [
		{
		  applicationId: 2,
		  companyName: "ИП Поставщик Куры",
		  createdAt: "18.09.2025 10:00:00",
		},
		{
		  applicationId: 2,
		  companyName: "ИП Поставщик Куры",
		  createdAt: "18.09.2025 10:00:00",
		},
		{
		  applicationId: 2,
		  companyName: "ИП Поставщик Куры",
		  createdAt: "18.09.2025 10:00:00",
		},
	  ],
	  expiringApplications: [],

	  meatType: {
		id: 2,
		nameRu: "КРС",
		nameKy: "Уй эти",
		alias: "BEEF",
	  },
	  title: "Квота на 2025 - год (Говядина)",
	},
	{
	  quotaComparePreviousMonth: {
		compare: "EQUAL",
		percentage: 0,
	  },
	  quotaId: 3,
	  totalVolume: 2500,
	  usagePercentage: 50,
	  totalAllocated: 2000,
	  deliveredVolume: 550600,
	  remainingVolume: 1000,

	  topNewSuppliers: [
		{
		  id: "1",
		  companyName: "ООО Мясокомбинат1",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1000,
		  totalAllocated: 3700,
		},
		{
		  id: "2",
		  companyName: "ООО Мясокомбинат2",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 5800,
		},
		{
		  id: "3",
		  companyName: "ООО Мясокомбинат3",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 5000,
		  totalAllocated: 6700,
		},
		{
		  id: "4",
		  companyName: "ООО Мясокомбинат4",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 3400,
		},
		{
		  id: "5",
		  companyName: "ООО Мясокомбинат5",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1500,
		  totalAllocated: 1600,
		}
	  ],
	  topHistoricalSuppliers: [
		{
		  id: "1",
		  companyName: "ООО Мясокомбинат1",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1000,
		  totalAllocated: 3700,
		},
		{
		  id: "2",
		  companyName: "ООО Мясокомбинат2",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 5800,
		},
		{
		  id: "3",
		  companyName: "ООО Мясокомбинат3",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 5000,
		  totalAllocated: 6700,
		},
		{
		  id: "4",
		  companyName: "ООО Мясокомбинат4",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 3400,
		},
		{
		  id: "5",
		  companyName: "ООО Мясокомбинат5",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1500,
		  totalAllocated: 1600,
		}
	  ],
	  antiTopNewSuppliers: [
		{
		  id: "1",
		  companyName: "ООО Мясокомбинат1",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1000,
		  totalAllocated: 3700,
		},
		{
		  id: "2",
		  companyName: "ООО Мясокомбинат2",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 5800,
		},
		{
		  id: "3",
		  companyName: "ООО Мясокомбинат3",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 5000,
		  totalAllocated: 6700,
		},
		{
		  id: "4",
		  companyName: "ООО Мясокомбинат4",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 3400,
		},
		{
		  id: "5",
		  companyName: "ООО Мясокомбинат5",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1500,
		  totalAllocated: 1600,
		}
	  ],
	  antiTopHistoricalSuppliers: [
		{
		  id: "1",
		  companyName: "ООО Мясокомбинат1",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1000,
		  totalAllocated: 3700,
		},
		{
		  id: "2",
		  companyName: "ООО Мясокомбинат2",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 5800,
		},
		{
		  id: "3",
		  companyName: "ООО Мясокомбинат3",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 5000,
		  totalAllocated: 6700,
		},
		{
		  id: "4",
		  companyName: "ООО Мясокомбинат4",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 2000,
		  totalAllocated: 3400,
		},
		{
		  id: "5",
		  companyName: "ООО Мясокомбинат5",
		  inn: "1234567890",
		  supplierType: "NEW_SUPPLIER",
		  deliveredVolume: 1500,
		  totalAllocated: 1600,
		}
	  ],

	  quotaNewSupplierTypeLimit: {
		supplierType: "NEW_SUPPLIER",
		totalAllocated: 1000,
		deliveredVolume: 500,
	  },
	  quotaHistoricalSupplierTypeLimit: {
		supplierType: "HISTORICAL_SUPPLIER",
		totalAllocated: 1500,
		deliveredVolume: 500,
	  },

	  quotaDeadlines: [
		{
		  deadlineInfo: "1-го этапа распределения для ИсП (1 декабря 2024) — прошёл",
		  daysUntilDeadline: 60,
		  deadlineDate: "2024-12-01",
		},
		{
		  deadlineInfo: "2-го этапа распределения для ИсП (1 апреля 2025) — прошёл",
		  daysUntilDeadline: 30,
		  deadlineDate: "2025-04-01",
		},
	  ],

	  newApplications: [
		{
		  applicationId: 2,
		  companyName: "ИП Поставщик Куры",
		  createdAt: "18.09.2025 10:00:00",
		},
		{
		  applicationId: 2,
		  companyName: "ИП Поставщик Куры",
		  createdAt: "18.09.2025 10:00:00",
		},
		{
		  applicationId: 2,
		  companyName: "ИП Поставщик Куры",
		  createdAt: "18.09.2025 10:00:00",
		},
	  ],
	  expiringApplications: [],

	  meatType: {
		id: 3,
		nameRu: "Свинины",
		nameKy: "Чочко эти",
		alias: "PORK",
	  },
	  title: "Квота на 2025 - год (Свинина)",
	},
  ],
  }
};
